import { render, staticRenderFns } from "./FormAssocianteFone.vue?vue&type=template&id=0b609f98"
import script from "./FormAssocianteFone.vue?vue&type=script&lang=js"
export * from "./FormAssocianteFone.vue?vue&type=script&lang=js"
import style0 from "./FormAssocianteFone.vue?vue&type=style&index=0&id=0b609f98&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports